import API from '../../../../../services/api';

export const WHATSAPP_API = {
    send: async (recordatorio) => {
        return API.post('whatsapp/recordatorio', recordatorio).then(res => res.data);
    },
    sendAll: async (recordatorios) => {
        return API.post('whatsapp/recordatorios', recordatorios).then(res => res.data);
    },
    archive: async (recordatorios) => {
        return API.post('whatsapp/archivar-recordatorios', recordatorios).then(res => res.data);
    }
}